import React, { useState, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";

import QuillMarkdown from "quilljs-markdown";
import "quilljs-markdown/dist/quilljs-markdown-common-style.css";

import Modal from "react-bootstrap/Modal";

const CustomToolbar = ({ openModal, openUpload, urlOptions }) => {
  return (
    <div id="toolbar">
      <select className="ql-header">
        <option value="1"></option>
        <option value="2"></option>
        <option value="3"></option>
        <option value="4"></option>
        <option value="5"></option>
        <option value="6"></option>
        <option selected></option>
      </select>

      <button className="ql-bold"></button>
      <button className="ql-italic"></button>
      <button className="ql-underline"></button>
      <button className="ql-strike"></button>
      <button className="ql-blockquote"></button>

      <button className="ql-list" value="ordered"></button>
      <button className="ql-list" value="bullet"></button>

      <button className="ql-indent" value="-1"></button>
      <button className="ql-indent" value="+1"></button>

      <select className="ql-align">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>

      <button className="ql-link"></button>
      <button className="ql-image"></button>
      <button className="ql-clean"></button>

      {urlOptions && (
        <button
          type="button"
          onClick={openModal}
          data-test="content-manage-google-drive"
          className="mr-3"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="48"
            height="48"
            viewBox="0 0 48 48"
          >
            <path fill="#FFC107" d="M17 6L31 6 45 30 31 30z"></path>
            <path fill="#1976D2" d="M9.875 42L16.938 30 45 30 38 42z"></path>
            <path fill="#4CAF50" d="M3 30.125L9.875 42 24 18 17 6z"></path>
          </svg>
        </button>
      )}

      {urlOptions && (
        <button type="button" onClick={openUpload} className="mr-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#ef8d23"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-file-plus"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
            <path d="M12 11l0 6" />
            <path d="M9 14l6 0" />
          </svg>
        </button>
      )}
    </div>
  );
};

const TextEditor = ({ value, setValue, formats, urlOptions }) => {
  const [files, setFiles] = useState(urlOptions);
  const [level, setLevel] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isUploadOpen, setUploadOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const quillRef = useRef(null);

  useEffect(() => {
    if (quillRef.current) {
      const quillInstance = quillRef.current.getEditor();
      new QuillMarkdown(quillInstance, {});
    }
  }, []);

  const insertLink = (label, url) => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    const localImageUrl = "/images/fileicon.png";

    if (range) {
      // // Insert an image at the current selection
      quill.insertEmbed(range.index, "image", localImageUrl);
      quill.setSelection(range.index, 1);
      quill.theme.tooltip.edit("link", url);
      quill.theme.tooltip.save();

      // // Get the editor's content and wrap the inserted image with a hyperlink
      // const editorContent = quill.root.innerHTML;
      // quill.root.innerHTML = editorContent.replace(
      //   `<img src="${localImageUrl}">`,
      //   `<a href="${url}" target="_blank"><img src="${localImageUrl}" style="width: 16px; height: 16px; display: inline-block"></a>`
      // );
      // quill.insertText(range.index, label, "user");
      // quill.setSelection(range.index, label.length);
    }

    setModalOpen(false);
    setFiles(urlOptions);
  };

  const insertUploadLink = (label, url) => {
    const quill = quillRef.current.getEditor();
    const range = quill.getSelection();
    const localImageUrl = "/images/fileicon.png";

    if (range) {
      quill.insertEmbed(range.index, "image", localImageUrl);
      quill.setSelection(range.index, 1);
      quill.theme.tooltip.edit("link", url);
      quill.theme.tooltip.save();
    }
    setUploadOpen(false);
  };

  // const insertUploadLink = (imageUrl, url) => {
  //   const quill = quillRef.current.getEditor();
  //   const range = quill.getSelection();
  //   const localImageUrl = "/images/fileicon.png";

  //   if (range) {
  //     // Insert an image at the current selection
  //     quill.insertEmbed(range.index, "image", localImageUrl);

  //     // Get the editor's content and wrap the inserted image with a hyperlink
  //     const editorContent = quill.root.innerHTML;
  //     quill.root.innerHTML = editorContent.replace(
  //       `<img src="${localImageUrl}">`,
  //       `<a href="${url}" target="_blank"><img src="${localImageUrl}" style="width: 16px; height: 16px; display: inline-block"></a>`
  //     );
  //   }

  //   setUploadOpen(false);
  // };

  const modules = {
    toolbar: {
      container: "#toolbar",
    },
  };

  const handleFolder = async (folderid) => {
    try {
      const response = await axios.get(
        "https://www.googleapis.com/drive/v3/files",
        {
          params: {
            q: `'${folderid}' in parents`,
            key: `${window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API}`,
            fields: "files(id, name, webViewLink, mimeType)",
            supportsAllDrives: true,
            includeItemsFromAllDrives: true,
          },
        }
      );

      setFiles(response.data.files);
      setLevel((prev) => prev + 1);
    } catch (error) {
      console.error(
        "Error fetching files:",
        error.response?.data || error.message
      );
    }
  };

  const uploadFile = async (file) => {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);

    const accessToken = localStorage.getItem("accessToken")

    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}upload/content/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${accessToken}`,
          },
        }
      );

      insertUploadLink(
        response.data["file_info"]["name"],
        response.data["file_info"]["webViewLink"]
      );
    } catch (error) {
      console.error("Upload failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];

    await uploadFile(file);
    event.target.value = "";
  };

  return (
    <div data-test="content-manage-quill">
      <CustomToolbar
        urlOptions={urlOptions}
        openModal={() => setModalOpen(true)}
        openUpload={() => setUploadOpen(true)}
      />
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={setValue}
        modules={modules}
        formats={formats}
      />

      {isModalOpen && (
        <Modal
          show={isModalOpen}
          onHide={() => setModalOpen(false)}
          className="modal-xl"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Add link from Google Drive</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="p-5"
            style={{ height: "600px", overflow: "auto" }}
          >
            {level > 0 && (
              <button
                onClick={() => {
                  setFiles(urlOptions);
                  setLevel((prev) => prev - 1);
                }}
              >
                Back
              </button>
            )}
            <div className="grid grid-cols-3 gap-x-10 gap-y-5">
              {files.map((option, index) => (
                <button
                  key={index}
                  onClick={() =>
                    option.mimeType === "application/vnd.google-apps.folder"
                      ? handleFolder(option.id)
                      : insertLink(option.name, option.webViewLink)
                  }
                  className="p-3 rounded border hover:text-[#ef8d23] "
                >
                  <i class="fa-brands fa-google-drive block"></i>
                  {option.name}
                </button>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}

      {isUploadOpen && (
        <Modal
          show={isUploadOpen}
          onHide={() => setUploadOpen(false)}
          className="modal"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload file</Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-5">
            <input type="file" onChange={handleFileChange} />
            {loading && (
              <>
                <span className="text-[#ef8d23]">Uploading</span>
                <span className="upload loading"></span>
              </>
            )}
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default TextEditor;
